class ClickableTextItem {
    public ItemId: string;
    public CreatedOn: string;
    public ClickableContent: string;
    public Context: string;
    public Language: string;
    public TabName: string;
    public TabOrderIndex: number;
    public ModifiedOn: string;
    public NbUser: number;
    public EmployeeGroupId: string;

    public IsHighlighted: boolean;
    public IsChecked: boolean;
    public Selected: boolean;
    public Visible: boolean;
    public ClickableContentItems: string[]; // ReadOnly

    public static DefaultTab(): ClickableTextItem {
        let cli = new ClickableTextItem();
        cli.TabName = "";
        cli.Context = "";
        cli.CreatedOn = null;
        cli.ClickableContent = "";
        cli.ClickableContentItems = [];
        cli.ItemId = "";
        cli.Language = sessionStore.userLanguageCode;
        cli.Selected = true;
        cli.TabOrderIndex = 99;
        cli.Visible = true;
        return cli;
    }
}

export { ClickableTextItem };
